// List of tile layer options for sealog maps.  Format conforms with Leaflet
// tilelayer object definitions. More information available at:
// https://leafletjs.com/reference.html#tilelayer
export const TILE_LAYERS = [
  {
    name: 'Esri Dark Gray',
    attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    maxNativeZoom: 11
  },
  {
    name: 'Esri Light Gray',
    attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    maxNativeZoom: 11
  },
  {
    name: 'Esri Ocean',
    attribution: 'Tiles &copy; Esri &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}',
    maxNativeZoom: 10,
    default: true
  },
  {
    name: 'GMRT Basemap',
    wms: true,
    url: 'https://www.gmrt.org/services/mapserver/wms_merc?map=/public/mgg/web/gmrt.marine-geo.org/htdocs/services/map/wms_merc.map&',
    attribution: '&copy 2023 <a href="http://gmrt.marine-geo.org" target="_blank" rel="noopener">GMRT</a>',
    layers: 'topo',
    transparent: false
  }
]

// List of overlay tilesets.  This can be set to an explicit list similar to
// TILE_LAYERS or to a url that returns the array
export const OVERLAY_LAYERS = [
  {
    name: 'Esri Ocean Labels',
    attribution: 'Tiles &copy; Esri &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Ocean/World_Ocean_Reference/MapServer/tile/{z}/{y}/{x}',
    maxNativeZoom: 10
  }
]

// Default location of map while data is loading or in the absence of position
// data.
export const DEFAULT_LOCATION = { lat: 41.38, lng: -71.5 }
